/* eslint-disable */
import * as Types from '../../../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetMainGrapesCountVariablesDTO = Types.Exact<{
  search?: Types.Maybe<Types.Scalars['String']>;
}>;


export type GetMainGrapesCountDTO = (
  { __typename?: 'Query' }
  & Pick<Types.QueryDTO, 'mainGrapesCount'>
);


export const GetMainGrapesCountDocumentDTO = gql`
    query getMainGrapesCount($search: String) {
  mainGrapesCount(filter: {archived: {equals: false}, name: {contains: $search}})
}
    `;

/**
 * __useGetMainGrapesCount__
 *
 * To run a query within a React component, call `useGetMainGrapesCount` and pass it any options that fit your needs.
 * When your component renders, `useGetMainGrapesCount` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainGrapesCount({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMainGrapesCount(baseOptions?: Apollo.QueryHookOptions<GetMainGrapesCountDTO, GetMainGrapesCountVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainGrapesCountDTO, GetMainGrapesCountVariablesDTO>(GetMainGrapesCountDocumentDTO, options);
      }
export function useGetMainGrapesCountLazyQueryDTO(baseOptions?: Apollo.LazyQueryHookOptions<GetMainGrapesCountDTO, GetMainGrapesCountVariablesDTO>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainGrapesCountDTO, GetMainGrapesCountVariablesDTO>(GetMainGrapesCountDocumentDTO, options);
        }
export type GetMainGrapesCountHookResult = ReturnType<typeof useGetMainGrapesCount>;
export type GetMainGrapesCountLazyQueryDTOHookResult = ReturnType<typeof useGetMainGrapesCountLazyQueryDTO>;
export type GetMainGrapesCountQueryResultDTO = Apollo.QueryResult<GetMainGrapesCountDTO, GetMainGrapesCountVariablesDTO>;